import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContentCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_607_15737",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 3,
		y: 2,
		width: 17,
		height: 19,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.05765 17.5C8.55252 17.5 8.12496 17.325 7.77498 16.975C7.42498 16.625 7.24998 16.1974 7.24998 15.6923V4.30773C7.24998 3.8026 7.42498 3.37503 7.77498 3.02503C8.12496 2.67503 8.55252 2.50003 9.05765 2.50003H17.4422C17.9473 2.50003 18.3749 2.67503 18.7249 3.02503C19.0749 3.37503 19.2499 3.8026 19.2499 4.30773V15.6923C19.2499 16.1974 19.0749 16.625 18.7249 16.975C18.3749 17.325 17.9473 17.5 17.4422 17.5H9.05765ZM9.05765 16H17.4422C17.5191 16 17.5897 15.968 17.6538 15.9039C17.7179 15.8397 17.7499 15.7692 17.7499 15.6923V4.30773C17.7499 4.2308 17.7179 4.16027 17.6538 4.09616C17.5897 4.03206 17.5191 4.00001 17.4422 4.00001H9.05765C8.98072 4.00001 8.9102 4.03206 8.8461 4.09616C8.78198 4.16027 8.74993 4.2308 8.74993 4.30773V15.6923C8.74993 15.7692 8.78198 15.8397 8.8461 15.9039C8.9102 15.968 8.98072 16 9.05765 16ZM5.55768 20.9999C5.05256 20.9999 4.625 20.8249 4.275 20.4749C3.925 20.1249 3.75 19.6974 3.75 19.1923V7.05771C3.75 6.84489 3.82179 6.66669 3.96538 6.52311C4.10898 6.37952 4.28718 6.30773 4.49998 6.30773C4.71279 6.30773 4.891 6.37952 5.0346 6.52311C5.17818 6.66669 5.24998 6.84489 5.24998 7.05771V19.1923C5.24998 19.2692 5.28202 19.3397 5.34613 19.4038C5.41024 19.4679 5.48076 19.5 5.55768 19.5H14.6922C14.905 19.5 15.0832 19.5718 15.2268 19.7154C15.3704 19.8589 15.4422 20.0371 15.4422 20.25C15.4422 20.4628 15.3704 20.641 15.2268 20.7846C15.0832 20.9281 14.905 20.9999 14.6922 20.9999H5.55768Z",
			fill: "#1C1B1F"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_607_15737)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#333333"
		})
	})]
});
export default SvgContentCopy;
